import { moduleFactory } from "@/factories/module";
import {
  hasPreviouslyVisitedLoginPage,
  recordVisitingLoginPage,
} from "@/modules/local-storage/landingPage";
import {
  _writeLocalStoragePendingRedirectPath,
  _clearLocalStoragePendingRedirectPath,
  _readLocalStoragePendingRedirectPath,
} from "@/modules/local-storage/redirect";
import {
  writeUpgradedUserEmail,
  clearUpgradedUserEmail,
  readUpgradedUserEmail,
} from "@/modules/local-storage/upgraded-user-email";
import {
  readStripeLastCheckoutSession,
  writeStripeLastCheckoutSession,
  clearStripeLastCheckoutSession,
} from "@/modules/local-storage/stripe-checkout-session";
import { writeThemeType, clearThemeType, readThemeType } from "@/modules/local-storage/theme";
import {
  writeGoogleCalendarOAuthState,
  readGoogleCalendarOAuthState,
  clearGoogleCalendarOAuthState,
} from "@/modules/local-storage/google-calendar-oauth-state";
import {
  writeOutlookCalendarOAuthState,
  readOutlookCalendarOAuthState,
  clearOutlookCalendarOAuthState,
} from "@/modules/local-storage/outlook-calendar-oauth-state";
import {
  _writeLocalStoragePendingEphemeralRouteAction,
  _clearLocalStoragePendingEphemeralRouteAction,
  _readLocalStoragePendingEphemeralRouteAction,
} from "@/modules/local-storage/ephemeral-route";

export const localStorageModule = moduleFactory.create({
  writePendingRedirectPath: _writeLocalStoragePendingRedirectPath,
  clearPendingRedirectPath: _clearLocalStoragePendingRedirectPath,
  readPendingRedirectPath: _readLocalStoragePendingRedirectPath,
  writePendingEphemeralRouteAction: _writeLocalStoragePendingEphemeralRouteAction,
  clearPendingEphemeralRouteAction: _clearLocalStoragePendingEphemeralRouteAction,
  readPendingEphemeralRouteAction: _readLocalStoragePendingEphemeralRouteAction,
  writeUpgradedUserEmail,
  clearUpgradedUserEmail,
  readUpgradedUserEmail,
  recordVisitingLoginPage,
  hasPreviouslyVisitedLoginPage,
  readStripeLastCheckoutSession,
  writeStripeLastCheckoutSession,
  clearStripeLastCheckoutSession,
  writeThemeType,
  clearThemeType,
  readThemeType,
  writeGoogleCalendarOAuthState,
  readGoogleCalendarOAuthState,
  clearGoogleCalendarOAuthState,
  writeOutlookCalendarOAuthState,
  readOutlookCalendarOAuthState,
  clearOutlookCalendarOAuthState,
});
